import { useId, useState } from 'react';
import { C, POLICE_CORPS } from '../../theme';

export function Champ({
  libelle,
  type = 'text',
  valeur,
  onChange,
  autoComplete,
  inputMode,
  aide,
  erreur,
  autoFocus,
}: {
  libelle: string;
  type?: string;
  valeur: string;
  onChange: (v: string) => void;
  autoComplete?: string;
  inputMode?: 'email' | 'text' | 'numeric';
  aide?: string;
  erreur?: string | null;
  autoFocus?: boolean;
}) {
  const id = useId();
  const idAide = `${id}-aide`;
  const enFaute = erreur !== undefined && erreur !== null;

  /**
   * Voir ce qu'on tape (2026-08-29, demande de la femme du porteur).
   *
   * Un mot de passe masque se tape a l'aveugle : sur un clavier de telephone, une
   * majuscule de trop et on est refuse sans savoir pourquoi. Montrer ce qu'on ecrit
   * evite l'erreur au lieu de la signaler apres coup.
   *
   * Pose ICI plutot que dans chaque ecran : ce composant sert la connexion,
   * l'inscription et la reinitialisation — l'oeil a un endroit et pas a l'autre serait
   * incomprehensible.
   */
  const [visible, setVisible] = useState(false);
  const estUnMotDePasse = type === 'password';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <label htmlFor={id} style={{ fontSize: 13, fontWeight: 700, color: C.secondaire }}>
        {libelle}
      </label>
      <div style={{ position: 'relative', display: 'flex' }}>
      <input
        id={id}
        type={estUnMotDePasse && visible ? 'text' : type}
        value={valeur}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        inputMode={inputMode}
        autoFocus={autoFocus}
        aria-invalid={enFaute || undefined}
        aria-describedby={aide !== undefined || enFaute ? idAide : undefined}
        style={{
          height: 48,
          border: `1px solid ${enFaute ? C.corailTexte : C.bordure}`,
          borderRadius: 12,
          // La place du bouton « Afficher », quand il y en a un : sans elle, le texte
          // passerait dessous.
          padding: estUnMotDePasse ? '0 84px 0 14px' : '0 14px',
          // 16 px au minimum : en dessous, iOS zoome tout seul quand le champ prend le
          // focus, et la page se retrouve de travers.
          fontSize: 16,
          fontFamily: POLICE_CORPS,
          color: C.encre,
          background: C.carte,
          outline: 'none',
          width: '100%',
          boxSizing: 'border-box',
        }}
      />
        {estUnMotDePasse ? (
          <button
            type="button"
            className="pressable"
            // Le libelle dit ce que fera le PROCHAIN appui : « Afficher » quand c'est
            // masque. Sans ce basculement, on ne sait plus dans quel etat on est.
            aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
            onClick={() => setVisible((v) => !v)}
            style={{
              position: 'absolute',
              right: 12,
              top: 0,
              height: 48,
              border: 'none',
              background: 'none',
              color: C.accent,
              fontSize: 12.5,
              fontWeight: 800,
              fontFamily: POLICE_CORPS,
              cursor: 'pointer',
              padding: 0,
            }}
          >
            {visible ? 'Masquer' : 'Afficher'}
          </button>
        ) : null}
      </div>
      {enFaute ? (
        <div id={idAide} style={{ fontSize: 12.5, fontWeight: 700, color: C.corailTexte }}>
          {erreur}
        </div>
      ) : aide !== undefined ? (
        <div id={idAide} style={{ fontSize: 12.5, color: C.tertiaire, lineHeight: 1.45 }}>
          {aide}
        </div>
      ) : null}
    </div>
  );
}
